import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationsService } from '@app/core/services/validations.service';
import { AppConfig } from '@config/app.config';
import { AccountingService } from '@core/services/accounting.service';
import { GeneralsService } from '@core/services/generals.service';
import { Constants } from '@shared/class/constants.class';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-balance-interface-download',
  templateUrl: './balance-interface-download.component.html'
})
export class BalanceInterfaceDownloadComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public balanceForm: FormGroup;
  public minDate = moment().subtract(91, 'days');
  public maxDate = moment().subtract(1, 'days');

  constructor(
    public appConfig: AppConfig,
    public accountingService: AccountingService,
    public generalsService: GeneralsService
  ) {}

  ngOnInit() {
    this.balanceForm = new FormGroup({
      typeDate: new FormControl('accountant', Validators.required),
      date: new FormControl('', [
        Validators.required,
        ValidationsService.isDateBetweenNinetyDaysFromYesterday
      ])
    });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.balanceForm;
    if (form.dirty && form.valid) {
      const loading = this.generalsService.loading();
      this.accountingService
        .downloadBalanceInterface(form)
        .pipe(takeUntil(this.constants.destroy$))
        .subscribe(
          result => {
            const fileName = this.generalsService.getFileName(
              result.headers.get('content-disposition')
            );
            this.generalsService.download(fileName, 'txt', result);
            loading.close();
          },
          error => {
            loading.close();
            this.generalsService.notification(
              this.appConfig.NOTIFICATION.error,
              this.generalsService.showError(error)
            );
          }
        );
    }
  }

  changeTypeDate(event: any) {
    const controlDate = this.balanceForm.controls['date'];
    controlDate.clearValidators();
    if (event.value === 'interface') {
      this.maxDate = moment();
      this.minDate = moment().subtract(90, 'days');
      controlDate.setValidators([
        Validators.required,
        ValidationsService.isDateBetweenNinetyDaysFromToday
      ]);
    } else {
      this.maxDate = moment().subtract(1, 'days');
      this.minDate = moment().subtract(91, 'days');
      controlDate.setValidators([
        Validators.required,
        ValidationsService.isDateBetweenNinetyDaysFromYesterday
      ]);
    }
    controlDate.updateValueAndValidity();
  }
}
